import Head from 'next/head'
import type { PropsWithChildren } from 'react'

export const NextHead = ({ children }: PropsWithChildren) => {
  if (process.env.NODE_ENV !== 'production') {
    return null
  }
  return <Head>{children}</Head>
}
